module.exports = __webpack_public_path__ + "static/img/empty.8dc6dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = Bm30
// module chunks = 0